import React from 'react';

import VectorIcon from 'assets/actionPlan/vector.svg';
import FilterSelect from 'pages/components/filterSelect';

import {
  AlertIcon,
  EmployeePill,
  ErrorForInputs,
  ErrorMessage,
  FormGrid,
  FormGroup,
  LabelSelect,
  RemoveButton,
  SelectedCount,
  SelectedEmployeesContainer,
  SummaryContainer,
  SummaryLabel,
  SummaryRow,
  SummaryText,
  Title,
} from '../EmployeeSteps.styles';

const Step2Selection = ({
  formData,
  errors,
  submitted,
  assignmentType,
  employeeData,
  departmentData,
  handleSelectWithAll,
  removeSelectedItem,
  resetSelectTrigger,
}) => {
  const selectedItems =
    assignmentType === 'employee' ? formData.selectedEmployees : formData.selectedDepartment;

  const hasSelection =
    (assignmentType === 'employee' && formData.selectedEmployees.length > 0) ||
    (assignmentType === 'department' && formData.selectedDepartment?.length > 0);

  return (
    <>
      <Title>{assignmentType === 'employee' ? 'Select Employees' : 'Select Department'}</Title>
      <FormGrid style={{ gridTemplateColumns: '1fr' }}>
        <FormGroup style={{ maxWidth: '400px' }}>
          <LabelSelect>
            {assignmentType === 'employee' ? 'Employees *' : 'Departments *'}
          </LabelSelect>
          <FilterSelect
            isStepVariant={true}
            key={assignmentType}
            title={
              assignmentType === 'employee' ? 'Select an employee' : 'Select a department'
            }
            showSearch={true}
            showAll={true}
            allTitle="All"
            allCheckedWhenEmpty={false}
            resetRegions={resetSelectTrigger}
            options={assignmentType === 'employee' ? employeeData : departmentData}
            onSelect={handleSelectWithAll}
            value={selectedItems}
            defaultValue={selectedItems}
            error={submitted ? errors.selectedEmployees || errors.selectedDepartment : null}
          />

          {submitted && (errors.selectedEmployees || errors.selectedDepartment) && (
            <ErrorForInputs>
              <AlertIcon src={VectorIcon} />
              <ErrorMessage>
                {errors.selectedEmployees || errors.selectedDepartment}
              </ErrorMessage>
            </ErrorForInputs>
          )}

          {hasSelection && (
            <SummaryContainer>
              <SummaryLabel>ASSIGNMENT SUMMARY</SummaryLabel>
              <SummaryRow>
                <SummaryText>
                  {assignmentType === 'employee' ? 'Users' : 'Departments'}
                </SummaryText>
                <SelectedEmployeesContainer>
                  {selectedItems.map((item) => (
                    <EmployeePill key={item.id}>
                      {item.label || item.name}
                      <RemoveButton onClick={() => removeSelectedItem(item.id)}>
                        ✕
                      </RemoveButton>
                    </EmployeePill>
                  ))}
                </SelectedEmployeesContainer>
              </SummaryRow>
            </SummaryContainer>
          )}
        </FormGroup>
      </FormGrid>

      <SelectedCount>
        Selected:{' '}
        {assignmentType === 'employee'
          ? `${formData.selectedEmployees.length} employee(s)`
          : `${formData.selectedDepartment?.length || 0} department(s)`}
      </SelectedCount>
    </>
  );
};

export default Step2Selection;
